window.fisherAnalytics.utils = {
    version: '1.0.0',
    enableLogging: function(flag) {
        if(typeof flag === 'boolean' && flag) {
            localStorage.setItem(window.fisherAnalytics.localStorageLoggingKey, 'true');
        } else {
            localStorage.removeItem(window.fisherAnalytics.localStorageLoggingKey);
        }
    },
    log: function(message) {
        if (localStorage.getItem(window.fisherAnalytics.localStorageLoggingKey)) {
            // Convert objects to string for logging
            if (typeof message === 'object' && message !== null) {
                try {
                    message = JSON.stringify(message, null, 2);
                } catch (e) {
                    message = String(message);
                }
            }
            console.log(message);
        }
        // Additionally, send log to backend if needed, controlled by config map value consumed at build time
        if(env.customAnalyticsLoggingEnabled) {
            this.sendLogToBackend(message);
        }
    },
    sendLogToBackend: function(message) {
        const browserDetails = navigator.userAgent;
        const fullMessage = `ANALYTICS LOGGING: ${message} | Browser: ${browserDetails}`;
        if (typeof window.utils.clientLogging === 'function') {
            window.utils.clientLogging(fullMessage);
        }
    },
    cleanAndConvertToFloat: function(value) {
        // Remove currency symbols and spaces
        let cleanedStr = value.replace(/[^\d.,-]/g, '');

        // Identify the decimal separator
        let lastComma = cleanedStr.lastIndexOf(',');
        let lastDot = cleanedStr.lastIndexOf('.');

        if (lastComma > lastDot) {
            // If the last comma comes after the last dot, comma is the decimal separator
            cleanedStr = cleanedStr.replace(/\./g, '').replace(/,/g, '.');
        } else if (lastDot > lastComma) {
            // If the last dot comes after the last comma, dot is the decimal separator
            cleanedStr = cleanedStr.replace(/,/g, '');
        }
        return parseFloat(cleanedStr);
    },
    getPageName: function() {
        if (window.digitalData && window.digitalData.page && window.digitalData.page.name) {
            return window.digitalData.page.name;
        }
        return "";
    },
    getPageURL: function() {
        if (window.digitalData && window.digitalData.page && window.digitalData.page.url) {
            return window.digitalData.page.url;
        }
        return "";
    },
    resolveFunctionPath: function(path, context) {
        if(typeof path !== 'string') {
            return;
        }
        context = context || window;
        var parts = path.split('.');
        for (var i = 0; i < parts.length; i++) {
            context = context[parts[i]];
        }
        return context;
    },
    parseQueryString: function(queryString) {
        let params;
        try {
            // Attempt to parse as JSON
            params = JSON.parse(queryString);
        } catch (e) {
            window.fisherAnalytics.utils.log("issue with parseQueryString() in utils " + e);
            // If parsing fails, proceed with query string parsing
            params = {};
            const pairs = queryString.split('&');

            pairs.forEach(pair => {
                const [key, value] = pair.split('=').map(decodeURIComponent);
                const keys = key.match(/[^[\]]+/g); // Extract keys from nested brackets

                // Navigate to the correct level in the params object
                let current = params;
                while (keys.length > 1) {
                    const k = keys.shift();
                    if (!current[k]) {
                        current[k] = isNaN(keys[0]) ? {} : []; // Create an object or array based on next key
                    }
                    current = current[k];
                }
                // Replace '+' with space if the key is 'addToCartFrom'
                if (keys[0] === 'addToCartFrom') {
                    current[keys[0]] = value.replace(/\+/g, ' ');
                } else {
                    current[keys[0]] = value;
                }
            });
        }
        return params;
    },
    addEvents: function(element,selectorName, selectorsConfig){
        if(element && element.hasAttribute('data-event-added')){
            return; // Event listener already added
        }
        var eventName = selectorsConfig[selectorName].eventName || 'click';
        var eventType = selectorsConfig[selectorName].eventType || 'click';
        var callback = selectorsConfig[selectorName].listenerCallback || function(){};
        var callBackArgs = selectorsConfig[selectorName].callBackArgs;

        // If callback is a string, resolve it to a function
        if (typeof callback === 'string') {
            callback = window.fisherAnalytics.utils.resolveFunctionPath(callback);
        }

        if (!element.hasAttribute('data-event-added')) {
            const listener = (event) => {
                if (Array.isArray(callback)) {
                    callback.forEach(func => {
                        if (typeof func === 'function') {
                            func(event, callBackArgs);
                        }
                    });
                } else {
                    if (typeof callback === 'function') {
                        callback(event, callBackArgs);
                    }
                }
            };

            element.addEventListener(eventType, listener);

            // Set the custom attribute to indicate the event listener has been added
            element.setAttribute('data-event-added', 'true');
            element.setAttribute('data-event-name', eventName);

            //Add cloned flag
            if(selectorsConfig[selectorName].useTargetClassname) {
                element.setAttribute('data-use-target-classname', selectorsConfig[selectorName].useTargetClassname);
            }
        }
    },
    initModules: function(selectorsToWatch, selectorsConfig) {
        selectorsToWatch.forEach(selectorName => {
            // Check for urlPattern property and match against current URL before processing elements
            if (selectorsConfig[selectorName] && Array.isArray(selectorsConfig[selectorName].urlPattern)) {
                var urlPatterns = selectorsConfig[selectorName].urlPattern;
                if (urlPatterns.length > 0) {
                    var matched = false;
                    for (var i = 0; i < urlPatterns.length; i++) {
                        if (window.location.href.indexOf(urlPatterns[i]) > 0) {
                            matched = true;
                            break;
                        }
                    }
                    if (!matched) {
                        return; // Skip this selectorName if no pattern matches
                    }
                }
            }
            const elements = document.querySelectorAll(`${selectorName}`);

            elements.forEach(element => {
                if (!element.hasAttribute('data-processed')) {
                    if (selectorsConfig[selectorName]) {
                        let targetElement = element;
                        if (selectorsConfig[selectorName].useParent && selectorsConfig[selectorName].parentSelector) {
                            const parent = element.closest(selectorsConfig[selectorName].parentSelector);
                            if (parent) {
                                targetElement = parent;
                            }
                        }
                        selectorsConfig[selectorName].method.forEach(func => {
                            if (typeof func === 'function') {
                                func(targetElement, selectorName, selectorsConfig);
                            }
                        });
                        // Mark as processed
                        element.setAttribute('data-processed', 'true');
                    }
                }
            });
        });
    }
};